import { COMING_SOON } from "@/data/site";
import Reveal from "@/components/ui/reveal";

export default function ComingSoon() {
    return (
        <section className="border-t border-border bg-gr-surface2 py-20 dark:bg-gr-dsurface lg:py-28">
            <div className="container-gr">
                <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
                    <div className="max-w-2xl">
                        <p className="font-mono text-xs uppercase tracking-[0.2em] text-gr-accent">Roadmapa</p>
                        <h2 className="mt-3 text-3xl tracking-tight text-foreground sm:text-4xl">Accountant Pro Plus — w przygotowaniu</h2>
                    </div>
                    <p className="text-sm text-muted-foreground">Funkcje wchodzą etapami: Q3 ’26 → Q1 ’27</p>
                </div>

                <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                    {COMING_SOON.map((c, i) => (
                        <Reveal
                            key={c.title}
                            delay={(i % 3) * 0.06}
                            className="relative rounded-2xl border border-border bg-card/60 p-6 backdrop-blur-sm"
                        >
                            <div data-testid={`coming-soon-${i}`}>
                                <span className="rounded-full bg-gr-secondary px-3 py-1 font-mono text-xs font-semibold text-gr-primary dark:bg-gr-dsecondary dark:text-gr-dprimary">{c.date}</span>
                                <h3 className="mt-4 text-lg tracking-tight text-foreground">{c.title}</h3>
                                <p className="mt-2 text-sm text-muted-foreground">{c.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
